import { render, staticRenderFns } from "./SearchModel.vue?vue&type=template&id=83d379e2&"
import script from "./SearchModel.vue?vue&type=script&lang=js&"
export * from "./SearchModel.vue?vue&type=script&lang=js&"
import style0 from "./SearchModel.vue?vue&type=style&index=0&id=83d379e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports